// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"8f0d1b83","239":"e39fb35b","341":"bbee73e8","342":"ccdee801","452":"ccca3654","455":"2186bbf4","551":"b0ffe9f2","598":"cb873d6c","672":"477a6254","699":"d0a44bce","842":"01821987","850":"7241f3bf","875":"efcc1565","961":"7cd6a412","977":"240addac","981":"d2107fbf"}[chunkId] + ".chunk.js";
};